import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LoadingService {
  $loading = signal<boolean>(false);

  showLoading(): void {
    this.$loading.set(true);
  }

  hideLoading(): void {
    this.$loading.set(false);
  }
}
